module.exports = __webpack_public_path__ + "img/spa-sauna.9ac5ae96.svg";